export default "__VITE_ASSET__L5ljS8Z0__"